import {EnumChecklistState} from "../resources/IChecklistManagement.resource";

export const ChecklistStatusFactory = (state: EnumChecklistState | string) => {
    switch (state) {
        case EnumChecklistState.APPROVED:
            return {
                name: 'Затверджено',
                color: '#CCFFD1'
            };
        case EnumChecklistState.DRAFT:
            return {
                name: 'Чернетка',
                color: '#EBEBEB'
            };
        default:
            return {
                name: 'Чернетка',
                color: '#EBEBEB'
            }
    }
};

export default ChecklistStatusFactory;
